<template>
  <div class="flex">
    <div class="inline-block pr-4 pb-4 w-1/2 items-start">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        <span v-if="summaryLabel">{{ summaryLabel }}</span>
        <span v-else>{{ label }}</span>
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <p
        v-if="value"
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black whitespace-pre-line break-words"
      >
        {{ value }}
      </p>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellTextarea",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    summaryLabel: {
      type: String
    },
    value: {
      type: String
    }
  },
};
</script>

<style lang="scss" scoped></style>
